import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "login-container" }
const _hoisted_2 = { class: "login-tabs" }
const _hoisted_3 = { class: "login-form" }
const _hoisted_4 = ["src"]
const _hoisted_5 = { style: {"margin":"0 0 20px"} }
const _hoisted_6 = { style: {"font-size":"12px"} }

import policyDialog from "./policyDialog.vue"
import privacyDialog from "./privacyDialog.vue"
import registerDialog from "./registerDialog.vue"
import passDialog from "./passDialog.vue"
import phoneDialog from "./phoneDialog.vue"
import studentDialog from "./studentDialog.vue"
import { ref } from 'vue';
import { login, getUserInfo, sendCode, getCaptcha } from "@/api/common.js"
import { ElMessage } from 'element-plus'
import { useStore } from "vuex"
import { useRouter } from 'vue-router';

export default /*@__PURE__*/_defineComponent({
  __name: 'loginDialog',
  props: {
    popupShow: {
        type: Boolean,
        default: false
    }
},
  emits: ['close'],
  setup(__props, { emit: __emit }) {

const router = useRouter();
const props = __props
const dialogShow = ref(props.popupShow)
const tabActive = ref('login')
const loginRef = ref()
const formData = ref({
    phone: '',
    code: '',
    password: '',
    flag: false,
    codephone: '',
    imgcode: ''
})
const policyShow = ref(false)
const privacyShow = ref(false)
const registerShow = ref(false)
const passShow = ref(false)
const phoneShow = ref(false)
const studentShow = ref(false)
const codeTime = ref(0)
let codeTimer = null
const userInfo = {}
const loginCodeImg = ref()
let nowUuid = ''
const emitList = __emit
const store = useStore();
const formRules = {
    phone: [
        {
            message: '请输入手机号/账号',
            validator: (rule: any, value: any, callback: any) => {
                if (!value) {
                    callback(new Error("请输入手机号/账号"))
                }
                callback()
            }
        }
    ],
    codephone: [
        {
            message: '请输入手机号',
            validator: (rule: any, value: any, callback: any) => {
                if (!value) {
                    callback(new Error("请输入手机号"))
                }
                callback()
            }
        }
    ],
    password: [
        {
            message: '请输入密码',
            validator: (rule: any, value: any, callback: any) => {
                if (!value) {
                    callback(new Error("请输入密码"))
                }
                callback()
            }
        }
    ],
    code: [
        {
            message: '请输入验证码',
            validator: (rule: any, value: any, callback: any) => {
                if (!value) {
                    callback(new Error("请输入验证码"))
                }
                callback()
            }
        }
    ],
    imgcode: [
        {
            message: '请输入图形验证码',
            validator: (rule: any, value: any, callback: any) => {
                if (!value) {
                    callback(new Error("请输入图形验证码"))
                }
                callback()
            }
        }
    ],
}

function phoneClose() {
    if (userInfo.firstLoginByPhone) {
        studentShow.value = true
        phoneShow.value = false;
    } else {
        getUserInfo().then(res => {
            store.dispatch('setLogin', res.data);
            emitList('close')
            router.go(0)
        })
    }
}

function studentClose() {
    emitList('close')
    router.go(0)
}

function tabClick(type) {
    if (type == tabActive.value) return
    tabActive.value = type;
    loginRef.value.clearValidate()
    if (type == 'codeLogin') {
        getImgCode()
    }
}

function loginEvent() {
    let validArr = ['phone', 'password']
    if (tabActive.value == 'codeLogin') {
        validArr = ['codephone', 'code', 'imgcode']
    }
    loginRef.value.validateField(validArr, valid => {
        if (valid) {
            if (!formData.value.flag) {
                return ElMessage.warning('请先阅读用户协议和隐私政策');
            }
            let params = {}
            if (tabActive.value == 'login') {
                params = {
                    phone: formData.value.phone,
                    password: formData.value.password,
                    type: 'student'
                }
            } else if (tabActive.value == 'codeLogin') {
                params = {
                    phone: formData.value.codephone,
                    code: formData.value.code,
                    type: 'student'
                }
            }
            console.log(params)
            login(params).then(res => {
                console.log(res)
                sessionStorage.setItem('token', res.data.jwt)
                getUser()
            }).catch(err => {
                console.log(err)
            })
        }
    })
}

function registerClose() {
    registerShow.value = false
    getUser()
}

function getUser() {
    getUserInfo().then(res => {
        store.dispatch('setLogin', res.data);
        store.dispatch('setGradeTerm', {
            grade: res.data.grade || '三年级',
            term: res.data.term || '上学期'
        })
        jumpEvent(res)
    })
}

function jumpEvent(res) {
    if (res.data.firstLoginByPassword) {
        phoneShow.value = true
    } else if (res.data.firstLoginByPhone) {
        studentShow.value = true
    } else {
        emitList('close')
        router.go(0)
    }
}

function closeEvent() {
    emitList('close')
}

function getCode() {
    if (codeTime.value > 0) {
        return ElMessage.warning('倒计时结束后再发送')
    } else {
        loginRef.value.validateField(['codephone', 'imgcode'], valid => {
            if (valid) {
                const params = {
                    phone: formData.value.codephone,
                    type: '01',
                    uuid: nowUuid
                }
                console.log(params)
                sendCode(params).then(res => {
                    ElMessage.success('验证码已发送')
                    codeTime.value = 60
                    codeTimer = setInterval(() => {
                        if (!codeTime.value) {
                            clearInterval(codeTimer)
                            codeTimer = null
                        } else {
                            codeTime.value--;
                        }
                    }, 1000)
                }).catch(err => {
                    console.log(err)
                })
            }
        })
    }
}
function getImgCode() {
    const randomNum = Math.floor(Math.random() * (99999999 - 10000000 + 1)) + 10000000;
    const uuid = `${randomNum}-${new Date().getTime()}`
    getCaptcha({
        uuid: uuid
    }).then(res => {
        loginCodeImg.value = 'data:image/png;base64,' + res.data;
        nowUuid = uuid
    })
}

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_el_divider = _resolveComponent("el-divider")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    modelValue: dialogShow.value,
    "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((dialogShow).value = $event)),
    width: "400px",
    center: "",
    onClose: closeEvent,
    "modal-class": "dialog-new-model"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _cache[22] || (_cache[22] = _createElementVNode("div", { class: "login-title" }, [
          _createTextVNode("HELLO,欢迎登陆 "),
          _createElementVNode("span", { class: "activeColor" }, "开悟作文")
        ], -1)),
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", {
            class: _normalizeClass(tabActive.value=='login'?'active':''),
            onClick: _cache[0] || (_cache[0] = ($event: any) => (tabClick('login')))
          }, "账号密码登陆", 2),
          _createElementVNode("div", {
            class: _normalizeClass(tabActive.value=='codeLogin'?'active':''),
            onClick: _cache[1] || (_cache[1] = ($event: any) => (tabClick('codeLogin')))
          }, "验证码登陆", 2)
        ]),
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_el_form, {
            ref_key: "loginRef",
            ref: loginRef,
            model: formData.value,
            rules: formRules
          }, {
            default: _withCtx(() => [
              (tabActive.value=='login')
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createVNode(_component_el_row, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_col, { span: 24 }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_form_item, { prop: "phone" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_input, {
                                  modelValue: formData.value.phone,
                                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((formData.value.phone) = $event)),
                                  placeholder: "请输入手机号/账号"
                                }, null, 8, ["modelValue"])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_row, { gutter: 20 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_col, { span: 16 }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_form_item, { prop: "password" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_input, {
                                  modelValue: formData.value.password,
                                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((formData.value.password) = $event)),
                                  placeholder: "请输入密码",
                                  type: "password",
                                  "show-password": ""
                                }, null, 8, ["modelValue"])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_col, { span: 8 }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_button, {
                              color: "#ef8b25",
                              plain: "",
                              onClick: _cache[4] || (_cache[4] = ($event: any) => (passShow.value=true))
                            }, {
                              default: _withCtx(() => _cache[17] || (_cache[17] = [
                                _createTextVNode("忘记密码")
                              ])),
                              _: 1,
                              __: [17]
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ], 64))
                : _createCommentVNode("", true),
              (tabActive.value=='codeLogin')
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createVNode(_component_el_row, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_col, { span: 24 }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_form_item, { prop: "codephone" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_input, {
                                  modelValue: formData.value.codephone,
                                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((formData.value.codephone) = $event)),
                                  placeholder: "请输入手机号"
                                }, null, 8, ["modelValue"])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_row, { gutter: 5 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_col, { span: 16 }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_form_item, { prop: "imgcode" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_input, {
                                  modelValue: formData.value.imgcode,
                                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((formData.value.imgcode) = $event)),
                                  placeholder: "请输入图形验证码"
                                }, null, 8, ["modelValue"])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_col, { span: 8 }, {
                          default: _withCtx(() => [
                            (loginCodeImg.value)
                              ? (_openBlock(), _createElementBlock("div", {
                                  key: 0,
                                  class: "loginCodeImg",
                                  onClick: getImgCode
                                }, [
                                  _createElementVNode("img", { src: loginCodeImg.value }, null, 8, _hoisted_4)
                                ]))
                              : _createCommentVNode("", true)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_row, { gutter: 5 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_col, { span: 16 }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_form_item, { prop: "code" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_input, {
                                  modelValue: formData.value.code,
                                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((formData.value.code) = $event)),
                                  placeholder: "请输入验证码"
                                }, null, 8, ["modelValue"])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_col, { span: 8 }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_button, {
                              color: "#ef8b25",
                              plain: "",
                              onClick: getCode
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(codeTime.value?`${codeTime.value}秒重新获取`:'获取验证码'), 1)
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ], 64))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["model"])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_el_checkbox, {
            modelValue: formData.value.flag,
            "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((formData.value.flag) = $event))
          }, {
            default: _withCtx(() => [
              _cache[18] || (_cache[18] = _createTextVNode(" 我已阅读并同意 ")),
              _createElementVNode("span", {
                class: "activeColor",
                onClick: _cache[8] || (_cache[8] = _withModifiers(($event: any) => (policyShow.value=true), ["stop"]))
              }, "《用户协议》"),
              _cache[19] || (_cache[19] = _createTextVNode("和 ")),
              _createElementVNode("span", {
                class: "activeColor",
                onClick: _cache[9] || (_cache[9] = _withModifiers(($event: any) => (privacyShow.value=true), ["stop"]))
              }, "《隐私政策》")
            ]),
            _: 1,
            __: [18,19]
          }, 8, ["modelValue"])
        ]),
        _createElementVNode("div", null, [
          _createVNode(_component_el_button, {
            style: {"width":"100%"},
            color: "#ef8b25",
            class: "footer-btn1",
            onClick: loginEvent
          }, {
            default: _withCtx(() => _cache[20] || (_cache[20] = [
              _createTextVNode("确认登陆")
            ])),
            _: 1,
            __: [20]
          })
        ]),
        _createElementVNode("div", null, [
          _createVNode(_component_el_divider, null, {
            default: _withCtx(() => [
              _createElementVNode("span", _hoisted_6, [
                _cache[21] || (_cache[21] = _createTextVNode("还没账号？ ")),
                _createElementVNode("span", {
                  class: "activeColor",
                  style: {"cursor":"pointer"},
                  onClick: _cache[11] || (_cache[11] = ($event: any) => (registerShow.value=true))
                }, "立即注册")
              ])
            ]),
            _: 1
          })
        ])
      ]),
      (policyShow.value)
        ? (_openBlock(), _createBlock(policyDialog, {
            key: 0,
            popupShow: policyShow.value,
            onClose: _cache[12] || (_cache[12] = ($event: any) => (policyShow.value=false))
          }, null, 8, ["popupShow"]))
        : _createCommentVNode("", true),
      (privacyShow.value)
        ? (_openBlock(), _createBlock(privacyDialog, {
            key: 1,
            popupShow: privacyShow.value,
            onClose: _cache[13] || (_cache[13] = ($event: any) => (privacyShow.value=false))
          }, null, 8, ["popupShow"]))
        : _createCommentVNode("", true),
      (registerShow.value)
        ? (_openBlock(), _createBlock(registerDialog, {
            key: 2,
            popupShow: registerShow.value,
            onClose: _cache[14] || (_cache[14] = ($event: any) => (registerShow.value=false)),
            onRegisterClose: registerClose
          }, null, 8, ["popupShow"]))
        : _createCommentVNode("", true),
      (passShow.value)
        ? (_openBlock(), _createBlock(passDialog, {
            key: 3,
            popupShow: passShow.value,
            onClose: _cache[15] || (_cache[15] = ($event: any) => (passShow.value=false))
          }, null, 8, ["popupShow"]))
        : _createCommentVNode("", true),
      (phoneShow.value)
        ? (_openBlock(), _createBlock(phoneDialog, {
            key: 4,
            popupShow: phoneShow.value,
            onClose: phoneClose
          }, null, 8, ["popupShow"]))
        : _createCommentVNode("", true),
      (studentShow.value)
        ? (_openBlock(), _createBlock(studentDialog, {
            key: 5,
            popupShow: studentShow.value,
            onClose: studentClose
          }, null, 8, ["popupShow"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})